/**
 * UserStore helpers for reading, writing, and removing CPT-related
 * data (CPT codes, J-codes, BO comments, auth-status-change comments)
 * from the in-memory session store.
 *
 * @module cptUserStoreHelpers
 */
import { UserGeneralInfoContextKeys } from "../../../../../enums/userGeneralInfoContextKeys";
import { UserStore } from "../../../../../store/UserGeneralInfoStore";
import { removeAuthStatusChangeCommentByJCode as removeCommentByJCode } from "../../../../../utils/orderDataHelpers";

/** @returns Cached CPT codes for the given order, or null */
export const getCptCodesFromStore = (orderId: string) =>
  UserStore.getItem(`${UserGeneralInfoContextKeys.CPT_CODES}_${orderId}`);

/** Persists CPT codes for the given order into the session store. */
export const setCptCodesToStore = (orderId: string, data: any) =>
  UserStore.setItem(`${UserGeneralInfoContextKeys.CPT_CODES}_${orderId}`, data);

/** Removes cached CPT codes for the given order. */
export const removeCptCodesFromStore = (orderId: string) =>
  UserStore.removeItem(`${UserGeneralInfoContextKeys.CPT_CODES}_${orderId}`);

/** Persists J-code list for the given order into the session store. */
export const setJCodesToStore = (orderId: string, data: any) =>
  UserStore.setItem(`${UserGeneralInfoContextKeys.J_CODES}_${orderId}`, data);

/** Removes cached BO comments for the given order. */
export const removeBoCommentsFromStore = (orderId: string) =>
  UserStore.removeItem(`${UserGeneralInfoContextKeys.BO_COMMENTS}_${orderId}`);

/** Removes cached auth-status-change comments for the given order. */
export const removeAuthStatusChangeCommentsFromStore = (orderId: string) =>
  UserStore.removeItem(
    `${UserGeneralInfoContextKeys.AUTH_STATUS_CHANGE_COMMENTS}_${orderId}`,
  );

/** Removes a single auth-status-change comment identified by J-code. */
export const removeAuthStatusChangeCommentByJCodeFromStore = (
  orderId: string,
  jCode: string,
) => removeCommentByJCode(orderId, jCode);
